module.exports = __webpack_public_path__ + "img/logo4.856bddb5.png";